import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js";

import api from "../../../api";
import PlantillaFormSections from "./PlantillaFormSections.js";

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            descripcion: '',
            asunto: '',
            cuerpo: ''
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    resetForm() {
        this.setState({
            descripcion: '',
            asunto: '',
            cuerpo: ''
        });
    }

    setSelects(data) {
        this.setState(() => ({
            descripcion: data.descripcion,
            asunto: data.asunto,
            cuerpo: data.cuerpo
        }));
    }

    createMarkup = () => {
        return {__html: this.state.cuerpo};
    }

    render() {

        return (
            <ParadigmaModal
                getUrl={api.email.plantillas.detail}
                onSubmit={(e) => this.props.onSubmit(e)}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Plantilla de Mail"}
                buttonTitle={"Ver"}
                className={"ui-modal-dialog ui-modal-editor"}
                buttonIcon={"fa fa-search fa-lg"}
                saveButton={false}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetForm()}
            >
                <div className="ui-form">
                    <PlantillaFormSections
                        disabled={true}
                        descripcion={this.state.descripcion}
                        asunto={this.state.asunto}
                        cuerpo={this.state.cuerpo}
                    />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/Config/Plantillas/Detail.js